const uiSchema = () => ({
  action_types: {
    'ui:enumNames': [
      'SET_IMAGES',
      'CREATE_ALL',
      'CREATE_PRODUCT',
      'UPDATE_PRODUCT',
      'UPDATE_PRODUCTSHOP',
      'UPDATE_ALL',
      'SYNC',
      'LEVEL_2',
      'INTERIOR',
      'ARCHIVE',
    ],
  },
});

export default uiSchema;
